const NOTIFICATIONS_URL = '/api/notifications';

type Notification = {
  title: string;
  message: string;
  date?: string;
  details: string;
  severity: string;
  source: string;
  host: string;
  path: string;
  userAgent: string;
};

export const sendNotification = async (notification: Notification) => {
  try {
    await fetch(NOTIFICATIONS_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(notification)
    });
  } catch (e) {
    console.warn('Failed to send notification', e);
  }
};
